// Date 2023-08-02 11:26:04

import sithMomMainProjectTemplate from "@/store/sithMesII/plan/SithMomMainProjectTemplateStore.js";
import sithMomMainProjectPlan from "@/store/sithMesII/plan/SithMomMainProjectPlanStore.js";
import sithMomMainProjectPlanDetail from "@/store/sithMesII/plan/SithMomMainProjectPlanDetailStore.js";
import sithMomMainProjectPlanScheduledRecord from "@/store/sithMesII/plan/SithMomMainProjectPlanScheduledRecordStore.js";

const genericEntities = [
    'sithMomMainProjectTemplate',
    'sithMomMainProjectPlan',
    'sithMomMainProjectPlanDetail',
    'sithMomMainProjectPlanScheduledRecord'
]

const entities = {
    sithMomMainProjectTemplate,
    sithMomMainProjectPlan,
    sithMomMainProjectPlanDetail,
    sithMomMainProjectPlanScheduledRecord
}

export {genericEntities}

export default entities
